import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-custom-message-tab',
  template: `<p-messages [(value)]="messages" [enableService]="false" [closable]="false"></p-messages>`
})
export class CustomMessageTabComponent {
  @Input() messages: any;

}
